var exports = {
  "kR": "AssetSourceModal.module__cards___TTd2Ml",
  "KI": "AssetSourceModal.module__cardsSingle___TTd2Ml",
  "Nr": "AssetSourceModal.module__card___TTd2Ml",
  "Ie": "AssetSourceModal.module__cardIcon___TTd2Ml",
  "PY": "AssetSourceModal.module__cardLabel___TTd2Ml",
  "eX": "AssetSourceModal.module__cardHint___TTd2Ml",
};

module.exports = exports;
